import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@share';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredPermissions: string[] = route.data['permissions']; // Get required permissions from route data

    if (this.authService.hasPermission(requiredPermissions)) {
      return true;
    } 
    else {
      this.router.navigate(['/auth/forbidden']); // Redirect to Unauthorized page
      return false;
    }
  }
}
